// extracted by mini-css-extract-plugin
export default {"toastError":"reset-password_toastError__SEKj-","toastSuccess":"reset-password_toastSuccess__YK5fM"};